(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laze-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  class LazeColourFilter extends HTMLElement {
    connectedCallback() {
      this.chips = [...this.querySelectorAll('[data-colour]')];
      this.clear = this.querySelector('[data-clear]');
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip.dataset.colour)));
      this.clear?.addEventListener('click', () => this.select(null));
      this.paintDots();
      const wanted = new URLSearchParams(location.search).get('color');
      if (wanted) this.select(wanted, true);
    }

    swatchInputs(colour) {
      return [...document.querySelectorAll('product-card input[type="radio"][name^="Color"]')].filter(
        (input) => input.value.toLowerCase() === colour.toLowerCase()
      );
    }

    paintDots() {
      this.chips.forEach((chip) => {
        const input = this.swatchInputs(chip.dataset.colour)[0];
        const label = input?.closest('label');
        const swatch = label?.querySelector('.swatch, [class*="swatch"]') || label;
        if (!swatch) return;
        const style = getComputedStyle(swatch);
        const dot = chip.querySelector('[data-dot]');
        if (style.backgroundImage && style.backgroundImage !== 'none') dot.style.backgroundImage = style.backgroundImage;
        else if (style.backgroundColor) dot.style.backgroundColor = style.backgroundColor;
      });
    }

    select(colour, silent) {
      this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(!!colour && chip.dataset.colour.toLowerCase() === colour.toLowerCase())));
      if (this.clear) this.clear.hidden = !colour;
      const url = new URL(location.href);
      if (colour) url.searchParams.set('color', colour); else url.searchParams.delete('color');
      history.replaceState(null, '', url);
      this.querySelectorAll('.laze-toolbar__pill').forEach((pill) => {
        const u = new URL(pill.getAttribute('href'), location.origin);
        if (colour) u.searchParams.set('color', colour); else u.searchParams.delete('color');
        pill.setAttribute('href', u.pathname + u.search);
      });
      if (!colour) return;
      const apply = () => this.swatchInputs(colour).forEach((input) => {
        if (input.checked) return;
        const label = input.closest('label');
        if (label) label.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      apply();
      if (silent) setTimeout(apply, 600);
    }
  }
  if (!customElements.get('laze-colour-filter')) customElements.define('laze-colour-filter', LazeColourFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
